import React, { useState } from 'react';
import { Drawer } from 'antd';
import { IMAGE_BASE_URL_OF_USER } from '../../constants';
import * as cts from '../../constants/ui/svg';
import noLogo from '../../assets/images/no-logo.png';
import { useLocation, useNavigate } from 'react-router-dom';
import { authActions } from 'slices/authSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { getToken } from 'helpers';
import logoRank from '../../assets/images/logo.png';
import { useTranslation } from 'react-i18next';
import MasterDefaultAvatar from '../../assets/images/master_default_avatar.png';
import { rankingAction } from 'slices/rankingSlice';

type Props = {
  setSelectMenu: React.Dispatch<React.SetStateAction<number>>;
  selectMenu: number;
  setOpenMenu: React.Dispatch<React.SetStateAction<boolean>>;
  openMenu: boolean;
  containerRef: any;
};

export default function NavMenu({
  setSelectMenu,
  setOpenMenu,
  openMenu,
  selectMenu,
  containerRef,
}: Props) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const token = getToken() as string;
  const { t } = useTranslation();
  const params = new URLSearchParams(location.search);
  const selectShop = useAppSelector((state) => state.shopList.selectShop);
  const masterInfo = useAppSelector((state) => state.auth.masterInfo);
  const [onErrorImg, setOnErrorImg] = useState(false);
  const redirectFrom = params.get('redirect_from');
  const menuTabShouldNavigate = redirectFrom === 'ranking_setting' ? 7 : 3;
  return (
    <Drawer
      getContainer={containerRef.current ?? false}
      title={
        <div className="flex items-center">
          <button className="mr-[24px]" onClick={() => setOpenMenu(false)}>
            <span>{cts.closeIcon}</span>
          </button>
          {/* <img className="h-[30px] w-[115px]" src={logoRank} /> */}
          <span>{cts.logoList}</span>
        </div>
      }
      placement="left"
      onClose={() => setOpenMenu(false)}
      open={openMenu}
      rootStyle={{ zIndex: 2000 }}
      className="draw_menu"
    >
      <div className="flex flex-col justify-between h-full">
        <div className="flex flex-col">
          <button
            onClick={() => {
              localStorage.removeItem('layout');
              localStorage.removeItem('selectedShop');
              localStorage.removeItem('ID_SELECTED_SHOP');
              localStorage.removeItem('shopSetting');
              localStorage.removeItem('dataDateRank');
              localStorage.removeItem('dataDateRankNearest');
              localStorage.removeItem('dataMonthRank');
              localStorage.removeItem('dataDateRankGroupShop');
              localStorage.removeItem('dataMonthRankGroupShop');
              navigate('/select-shop');
            }}
            className="flex items-center justify-between border-b border-[#D5D7DA] border-solid h-[60px] px-[16px]"
          >
            <div className="flex items-center">
              {/* <img
                className="h-[32px] w-[32px] rounded-[16px] mr-[16px] object-cover border-[#D5D7DA] border-solid border"
                src={
                  selectShop?.avatar_image && !onErrorImg
                    ? `${IMAGE_BASE_URL_OF_USER}/shop/logo/${selectShop?.avatar_image}`
                    : noLogo
                }
                onError={() => setOnErrorImg(true)}
              /> */}
              {masterInfo.active ? (
                selectShop.id ? (
                  <img
                    className="h-[32px] w-[32px] rounded-[20px] mr-[12px] object-cover border-border-gray border-solid border"
                    src={
                      selectShop?.avatar_image && !onErrorImg
                        ? `${IMAGE_BASE_URL_OF_USER}/shop/logo/${selectShop?.avatar_image}`
                        : noLogo
                    }
                    onError={() => setOnErrorImg(true)}
                  />
                ) : (
                  <img
                    className="h-[32px] w-[32px] rounded-full mr-3 object-cover border border-solid border-border-gray"
                    src={MasterDefaultAvatar}
                  />
                )
              ) : (
                <img
                  className="h-[32px] w-[32px] rounded-[20px] mr-[12px] object-cover border-border-gray border-solid border"
                  src={
                    selectShop?.avatar_image && !onErrorImg
                      ? `${IMAGE_BASE_URL_OF_USER}/shop/logo/${selectShop?.avatar_image}`
                      : noLogo
                  }
                  onError={() => setOnErrorImg(true)}
                />
              )}

              <span className="text-[16px] notosans_medium text-[#182230]">
                {masterInfo.active
                  ? selectShop.id
                    ? selectShop.name
                    : t('ADMINISTRATOR_MODE')
                  : selectShop.name}
              </span>
            </div>
            <span>{cts.changeShop}</span>
          </button>
          <button
            onClick={() => {
              setSelectMenu(1);
              dispatch(rankingAction.resetOrderByImagesSLiderRanking());
              navigate(`/rank${redirectFrom ? `?redirect_from=${redirectFrom}` : ''}`);
            }}
            className={`${
              selectMenu === 1 ? 'bg-primary' : 'bg-white'
            } flex items-center border-b border-border-gray border-solid h-[60px] px-[16px]`}
          >
            <div className="mr-[9px]">{selectMenu === 1 ? cts.activeRanking : cts.ranking}</div>

            <span
              className={`${
                selectMenu === 1 ? 'text-white' : 'text-primary'
              } text-[16px] notosans_medium`}
            >
              {t('RANKING')}
            </span>
          </button>
          <button
            onClick={() => {
              setSelectMenu(2);
              navigate(`/settings?tab=${String(menuTabShouldNavigate)}`);
            }}
            className={`${
              selectMenu === 2 ? 'bg-primary' : 'bg-white'
            } flex items-center border-b border-border-gray border-solid h-[60px] px-[16px]`}
          >
            <div className="mr-[9px]">{selectMenu === 2 ? cts.activeSetting : cts.setting}</div>

            <span
              className={`${
                selectMenu === 2 ? 'text-white' : 'text-primary'
              } text-[16px] notosans_medium`}
            >
              {t('SETTING')}
            </span>
          </button>
        </div>
        <button
          onClick={() => {
            localStorage.removeItem('ID_SELECTED_SHOP');
            localStorage.removeItem('SELECTED_SHOP_ID');
            localStorage.removeItem('selectedShop');
            dispatch(authActions.logout({ token, params: { notification_token: '' } }));
          }}
          className="flex items-center border-t border-[#D5D7DA] border-solid h-[60px] px-[16px] w-full"
        >
          <div className="mr-[5px] icon_log flex items-center justify-center">{cts.logOutIcon}</div>
          <span className="text-[16px] notosans_normal text-[#F04438]">{t('LOGOUT')}</span>
        </button>
      </div>
    </Drawer>
  );
}
